import type { ReactNode } from "react";

import PbsLogo from "./PbsLogo";

type Props = {
  children: ReactNode;
};

export default function AuthPageShell({ children }: Props) {
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <section className="relative hidden flex-1 flex-col justify-between overflow-hidden bg-foreground p-12 text-background lg:flex">
        <div className="absolute inset-0 opacity-[0.03]" aria-hidden="true">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "linear-gradient(currentColor 1px, transparent 1px), linear-gradient(90deg, currentColor 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
        </div>

        <div
          className="pointer-events-none absolute -top-20 -right-20 h-80 w-80 rounded-full bg-chart-1/20 blur-3xl"
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-chart-3/15 blur-3xl"
          aria-hidden="true"
        />

        <div className="relative z-10">
          <PbsLogo className="h-12 w-auto" />
        </div>

        <div className="relative z-10 max-w-md space-y-4">
          <h1 className="text-4xl font-bold leading-tight tracking-tight">
            PBS Connect
          </h1>
          <p className="text-lg leading-relaxed text-background/60">
            Connecting Every Step of Care
          </p>
        </div>

        <div className="relative z-10 text-sm text-background/40">
          &copy; {new Date().getFullYear()} Team PBS
        </div>
      </section>

      <main className="flex flex-1 flex-col lg:max-w-xl">
        <div className="flex items-center px-6 py-4 lg:hidden">
          <PbsLogo className="h-10 w-auto" />
        </div>

        <div className="flex flex-1 items-center justify-center px-6 py-10">
          <div className="w-full max-w-sm space-y-5">{children}</div>
        </div>
      </main>
    </div>
  );
}
